const weekdays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const eventSeriesScheduleSummary = (eventSeries) => {
  const {
    recurringType,
    separationCount,
    dayOfWeek,
    weekOfMonth,
    dayOfMonth,
  } = eventSeries;

  let skipMessage;
  const intSeparationCount = parseInt(separationCount, 10);
  if (intSeparationCount === 0) {
    skipMessage = '';
  } else if (intSeparationCount === 1) {
    skipMessage = 'other ';
  } else if (intSeparationCount > 1) {
    skipMessage = `${intSeparationCount + 1} `;
  }

  if (recurringType === 'CUSTOM') {
    return 'Custom, non-repeating series';
  } else if (recurringType === 'WEEKLY') {
    return `Every ${skipMessage}week${separationCount > 1 ? 's' : ''} on ${
      dayOfWeek ?
        weekdays[parseInt(dayOfWeek, 10) - 1] :
        'MUST CHOOSE DAY OF WEEK'
    }`;
  } else if (recurringType === 'MONTHLY') {
    return `Every ${skipMessage}month${separationCount > 1 ? 's' : ''} on ${
      dayOfMonth ?
        `day ${dayOfMonth}` :
        (weekOfMonth ?
          `week ${weekOfMonth.toLowerCase()} on ${
            dayOfWeek ?
              weekdays[parseInt(dayOfWeek, 10) - 1] :
              'MUST CHOOSE DAY OF WEEK'
          }` :
          'MUST CHOOSE DAY OF MONTH OR WEEK OF MONTH'
        )
    }`;
  }
};
